var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_5778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0831 18.8155L3.73047 9.3125L3.76828 22.5559L20.12 32.0591L20.0831 18.8155ZM20.1277 34.7136L3.77586 25.2109L3.79094 30.4987L20.1427 40.0018L20.1277 34.7136Z",
    fill: "#E94646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0841 18.8137L3.73145 9.3107L19.8584 0L36.2102 9.50266L20.0841 18.8137Z",
    fill: "#FFAB49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2755 9.5L36.2906 14.7993L27.0771 20.1195L27.0848 22.7748L36.298 17.4549L36.3358 30.6866L20.209 39.9973L20.1939 34.7091L29.4086 29.39L29.4012 26.7344L20.1863 32.0545L20.1494 18.8111L36.2755 9.5Z",
    fill: "#FFC895"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_5778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/NewLogo.0df113c0efc54e648e22e9403a48580a.svg";
export { ForwardRef as ReactComponent };